import { useCallback, useContext } from 'react'

import { AppContext } from '@/components/context/AppContext'
import type { TranslationsType } from '@/types/i18n'

let cacheStorage: Record<string, string> = {}

export const  clearCacheStorage = () => {
  cacheStorage = {};
}

const useTranslation = () => {
  const { i18n } = useContext(AppContext)

  const t = useCallback(<Key extends keyof TranslationsType>(key: Key, params: Record<string, string> = {}): string => {
    const cacheKey = `${key}::${JSON.stringify(params)}`

    if (cacheStorage[cacheKey]) {
      return cacheStorage[cacheKey]
    }

    const value = i18n?.translate(key, params) || key
    cacheStorage[cacheKey] = value

    return value
  }, [i18n])

  return {
    t
  }
}

export default useTranslation
